import { createSlice } from "@reduxjs/toolkit";
import { userLogin } from "../actions/authenticationService";

const initialState={
    loading:false,
    loginInfo:null,
    error:null,
    success:false
}

const authSlice = createSlice({
    name:"auth",
    initialState,
    extraReducers:(builder)=>{
        builder
        .addCase(userLogin.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success =false;
        })
        .addCase(userLogin.fulfilled, (state,{payload}) => {
            state.loading=false;
            state.loginInfo=payload;
            state.success=true;
            state.error=null;
        })
        .addCase(userLogin.rejected,(state, {paylaod})=>{
            state.loading=false;
            state.error=paylaod;
            state.success=false;
        })
    }
});

export default authSlice.reducer;